export default "__VITE_ASSET__BfqyNcO9__"